import script from "./TestResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TestResult.vue?vue&type=script&setup=true&lang=js"

import "./TestResult.vue?vue&type=style&index=0&id=50664096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50664096"]])

export default __exports__